import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ImportFileSelector;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Button } from '@instructure/ui-buttons';
import { Grid } from '@instructure/ui-grid';
import { jsx } from '@instructure/emotion';
import { IconUploadLine, IconCompleteLine } from '@instructure/ui-icons';
import t from '@instructure/quiz-i18n/format-message';
import FileSelector from '../../../../common/components/shared/file_selector/FileSelector';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var ImportFileSelector = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ImportFileSelector = /*#__PURE__*/function (_Component) {
  function ImportFileSelector() {
    _classCallCheck(this, ImportFileSelector);
    return _callSuper(this, ImportFileSelector, arguments);
  }
  _inherits(ImportFileSelector, _Component);
  return _createClass(ImportFileSelector, [{
    key: "renderUploadIcon",
    value: function renderUploadIcon(styles) {
      return jsx("div", {
        css: this.props.styles.uploadIconContainer
      }, jsx(IconUploadLine, null));
    }
  }, {
    key: "renderCheckmarkIcon",
    value: function renderCheckmarkIcon(styles) {
      return jsx("div", {
        css: styles.checkIconContainer
      }, jsx(IconCompleteLine, null));
    }
  }, {
    key: "renderFileList",
    value: function renderFileList(styles) {
      var fileName = this.props.files.get(0).name;
      return jsx("div", null, t.rich('<0>{fileName}</0> <1>is ready.</1>', {
        0: function _(_ref) {
          var children = _ref.children;
          return jsx("span", {
            css: styles.fileListSuccess,
            key: "0"
          }, children);
        },
        1: function _(_ref2) {
          var children = _ref2.children;
          return jsx("span", {
            key: "1"
          }, children);
        },
        fileName: fileName
      }));
    }
  }, {
    key: "renderFilePickerText",
    value: function renderFilePickerText(styles) {
      return jsx("div", null, t.rich('Drag & Drop here <0>or</0> <1>Browse</1>', [function (_ref3) {
        var children = _ref3.children;
        return jsx("span", {
          css: styles.smallText,
          key: "0"
        }, children);
      }, function (_ref4) {
        var children = _ref4.children;
        return jsx(Button, {
          key: "1"
        }, children);
      }]));
    }
  }, {
    key: "renderWrapperWithList",
    value: function renderWrapperWithList(styles) {
      return jsx(Grid, null, jsx(Grid.Row, {
        vAlign: "middle"
      }, jsx(Grid.Col, {
        width: 3
      }, this.renderCheckmarkIcon(styles)), jsx(Grid.Col, null, this.renderFileList(styles))));
    }
  }, {
    key: "renderWrapperWithText",
    value: function renderWrapperWithText(styles) {
      return jsx(Grid, null, jsx(Grid.Row, {
        vAlign: "middle"
      }, jsx(Grid.Col, {
        width: 3
      }, this.renderUploadIcon(styles)), jsx(Grid.Col, null, this.renderFilePickerText(styles))));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var files = this.props.files;
      if (files && files.size) {
        return this.renderWrapperWithList(this.props.styles);
      } else {
        return this.renderWrapperWithText(this.props.styles);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        styles = _this$props.styles,
        receiveFile = _this$props.receiveFile,
        acceptAttribute = _this$props.acceptAttribute;
      return jsx("div", {
        css: styles.selector
      }, jsx(FileSelector, {
        content: this.renderContent(),
        fileHandler: receiveFile,
        acceptAttribute: acceptAttribute
      }));
    }
  }]);
}(Component), _defineProperty(_ImportFileSelector, "displayName", 'ImportFileSelector'), _defineProperty(_ImportFileSelector, "componentId", "Quizzes".concat(_ImportFileSelector.displayName)), _defineProperty(_ImportFileSelector, "propTypes", {
  files: ImmutablePropTypes.list.isRequired,
  receiveFile: PropTypes.func.isRequired,
  acceptAttribute: PropTypes.string.isRequired,
  styles: PropTypes.object
}), _ImportFileSelector)) || _class);
export default ImportFileSelector;